import {
  MutatedExperimentVariant,
  OriginalExperimentState,
} from 'modules/experiments/takeover/types';
import { colors } from 'ui/theme';
import { sortControlVariantFirst } from './variantTable';
import { variantAlphabet } from './variantAlphabet';

type ColorTruple = {
  bgColor: string;
  textColor: string;
  borderColor: string;
};

const COLOR_MAP: ColorTruple[] = [
  {
    bgColor: colors.purple10,
    textColor: colors.purple100,
    borderColor: colors.purple20,
  },
  {
    bgColor: colors.green10,
    textColor: colors.green100,
    borderColor: colors.green20,
  },
  {
    bgColor: colors.mustard10,
    textColor: colors.mustard100,
    borderColor: colors.mustard20,
  },
  {
    bgColor: colors.cyan10,
    textColor: colors.cyan100,
    borderColor: colors.cyan20,
  },
  {
    bgColor: colors.salmon10,
    textColor: colors.salmon100,
    borderColor: colors.salmon20,
  },
];

export const mutateEditExperimentVariantState = (
  variants: OriginalExperimentState['variations'],
): MutatedExperimentVariant[] =>
  sortControlVariantFirst(variants).map((variant, index) => ({
    ...variant,
    alphabet: variantAlphabet(index),
    ...COLOR_MAP[index % COLOR_MAP.length],
  }));
